define(function(require, exports, module) {
    'use strict';

    var Class = require('Class');
    var AnimationManager = require('managers/animation.manager');

    module.exports = Class.create(AnimationManager, {

        _configTemplate: {
            animationEnabled: false,
            animationsMap: {
                // accordion
                'fn-accordion': ['accordionEffect'],

                // gamesinfo nav item
                'gamesinfo__nav-item': ['circularEffect'],

                // menu slider
                'menu__navigation': ['slideLineMenu'],

                // list item (language list, expanded list, menu list, game list)
                'language-list__point': ['circularEffect'],
                'gamesinfo__list-row': ['circularEffect'],
                'info-list__header': ['circularEffect'],
                'slide-menu__point__name': ['circularEffect'],
                'slide-menu__list__header': ['circularEffect']
            },
            gamesinfoComingUp: false,
            gamesinfoRearrange: false
        }
    });
});
